import { call } from 'redux-saga/effects';

let setInfoModule = null;
export function* setInfoAccount({ payload }) {
  if (!setInfoModule) {
    setInfoModule = yield call(() => import('./set-info'));
  }
  yield call(setInfoModule.setInfo, { payload });
}
let progressOtpModule = null;
export function* progressOtpAccount({ payload }) {
  if (!progressOtpModule) {
    progressOtpModule = yield call(() => import('./progress-otp'));
  }
  yield call(progressOtpModule.progressOtp, { payload });
}
let progressObdModule = null;
export function* progressObdAccount() {
  if (!progressObdModule) {
    progressObdModule = yield call(() => import('./progress-obd'));
  }
  yield call(progressObdModule.progressObd, {});
}
let sendOtpModule = null;
export function* sendOtpAccount({ payload }) {
  if (!sendOtpModule) {
    sendOtpModule = yield call(() => import('./send-otp'));
  }
  yield call(sendOtpModule.sendOtp, {
    payload,
  });
}
let validateOtpModule = null;
export function* validateOtpAccount({ payload }) {
  if (!validateOtpModule) {
    validateOtpModule = yield call(() => import('./validate-otp'));
  }
  yield call(validateOtpModule.validateOtp, {
    payload,
  });
}
